import { Button, useAnalytic } from 'src/components'
import { ETrackingEvent } from 'src/enums'
import { useBehaviorMapper } from 'src/hooks'
import { ModalChangePassword } from 'src/partials/modal-change-password'
import { DialogService } from 'src/services'
import { AuthModule } from 'src/store'
import { AssociatedCompaniesSection } from '../profile-component/associated-companies-section'
import { AvatarSection } from '../profile-component/avatar-section'
import { CompanySection } from '../profile-component/company-section'
import { PhoneSection } from '../profile-component/phone-section'
import { ProfileBlock } from '../profile-component/profile-block'
import { ProfileRow } from '../profile-component/profile-row'
import { RecruiterRolesSection } from '../profile-component/recruiter-roles-section'

interface IProps {
  screen?: string
}

export const Information = ({ screen }: IProps) => {
  const profile = useBehaviorMapper(AuthModule.profile$)
  const { eventHandler } = useAnalytic(screen ?? 'settings')
  const isRecruiter = useBehaviorMapper(AuthModule.isRecruiter$)

  return (
    <div className="fx-1 fx-column gap-8">
      <AvatarSection screen={screen}/>

      <ProfileBlock>
        <ProfileRow label="Email" value={profile?.email}/>
        <ProfileRow
          label="Password"
          value={(
            <Button
              variant="secondary"
              className="fx-as-flex-start"
              onClick={eventHandler(ETrackingEvent.BTN_SETTING_RESET_PASSWORD, () => DialogService.open(ModalChangePassword, { screen }))}
            >
              Reset Password
            </Button>
          )}
        />
      </ProfileBlock>

      <PhoneSection screen={screen}/>

      <CompanySection screen={screen}/>

      {isRecruiter && (
        <>
          <AssociatedCompaniesSection screen={screen}/>
          <RecruiterRolesSection screen={screen}/>
        </>
      )}
    </div>
  )
}
